import { render, staticRenderFns } from "./FollowerOverview.vue?vue&type=template&id=37159d0e&scoped=true"
import script from "./FollowerOverview.vue?vue&type=script&lang=js"
export * from "./FollowerOverview.vue?vue&type=script&lang=js"
import style0 from "./FollowerOverview.vue?vue&type=style&index=0&id=37159d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37159d0e",
  null
  
)

export default component.exports